import Fab from '@mui/material/Fab';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const CartButton = (props) => {
    const { cartCount, setCartOpen } = props;

    return (
        <Fab
            color="primary"
            style={{ position: 'fixed', right: 0, bottom: '50%', zIndex: 1400, borderRadius: '5px 0 0 5px', display: 'block', minHeight: '80px' }}
            onClick={() => setCartOpen(true)}
        >
            <div style={{ padding: '10px' }}>
                <div style={{ fontSize: '18px', }}>{cartCount}</div>
                <div><ShoppingCartIcon /></div>
            </div>
        </Fab>
    )   
};

export default CartButton;

